<script>
export default {
    name: 'IconVirement'
}
</script>
<template>
    <svg
        class="base-icon icon-virement"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M38 14c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zm1.46 8c-1.518 0-2.927.285-4.227.856a9.213 9.213 0 00-3.312 2.431 9.597 9.597 0 00-1.963 3.647H27v2.32h2.565a7.769 7.769 0 00-.026.746c0 .331.009.58.026.746H27v2.32h2.958a9.597 9.597 0 001.963 3.647 9.213 9.213 0 003.312 2.43c1.3.572 2.71.857 4.228.857 1.588 0 3.023-.295 4.306-.884A8.569 8.569 0 0047 38.547l-2.696-2.652c-1.257 1.529-2.801 2.293-4.634 2.293-1.152 0-2.181-.276-3.089-.829a5.514 5.514 0 01-2.094-2.293h6.623v-2.32h-7.278a7.769 7.769 0 01-.026-.746c0-.331.009-.58.026-.746h7.278v-2.32h-6.623a5.514 5.514 0 012.094-2.293c.908-.553 1.937-.829 3.09-.829 1.814 0 3.359.755 4.633 2.265L47 25.425a8.68 8.68 0 00-3.233-2.541c-1.283-.59-2.718-.884-4.306-.884zM8 30h8v4H8v-4zm6-10h4v4h-4v-4zm0 20h4v4h-4v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
